export default __webpack_public_path__ + "static/media/57.f63a3b75.png";